export enum Column {
  Date = 'Date',
  Sum = 'Sum',
  Type = 'Type',
  Comment = 'Comment'
}
